// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1ftlG","addWidgetButton":"Header_addWidgetButton__o92Aj","dashboardTabs":"Header_dashboardTabs__22vpE","active":"Header_active__3H4O3"};